import { Component, Input } from '@angular/core';
import { AbstractPage } from "../../pages/_com/abstract-page";

/**
 * Generated class for the TabetakotoaruViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'app-tabetakotoaru-view',
  templateUrl: 'tabetakotoaru-view.html'
})
export class TabetakotoaruViewComponent extends AbstractPage  {

  @Input() tabetakotoaru_foods: any;

  constructor() {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/components/tabetakotoaru-view/tabetakotoaru-view.ts